{
  "created_by": "Creado por",
  "created": "Creado",
  "filter": "Filtrar",
  "example": {
    "test": "Mi nombre es {{ name }} y tengo {{ age }} años"
  },
  "buttons": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "save_changes": "Guardar cambios",
    "next": "Siguiente",
    "continue": "Continuar",
    "close": "Cerrar",
    "selectValue": "Selecciona {{ value }}",
    "remove": "Eliminar",
    "confirm": "Confirmar",
    "saveAndFinish": "Guarda y termina",
    "saveAndClose": "Guardar y cerrar",
    "back": "Atrás",
    "copyValue": "Copiar valor",
    "pasteValue": "Pegar el valor",
    "delete": "Eliminar",
    "deleting": "Eliminando",
    "deleteAll": "Eliminar todo",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "import": "Importar",
    "export": "Exportación",
    "add": "Agregar",
    "share": "Compartir",
    "key": "Clave",
    "create": "Crear",
    "expand": "Expandir",
    "collapse": "Colapso",
    "select": "Seleccione",
    "select_all": "Selecciona todo",
    "upload": "Subir",
    "download": "Descargar",
    "add_another_item": "Añadir otro artículo",
    "move": "Muévete",
    "edit": "Editar",
    "edit_name": "Editar nombre",
    "removeImage": "Eliminar imagen",
    "finish": "Finalizar",
    "click_to_edit": "Haga clic para editar {{ name }}",
    "click_to_select": "Haga clic para seleccionar {{ name }}",
    "click_to_deselect": "Haga clic para deseleccionar {{ name }}",
    "see_all": "Ver todos",
    "skip": "Saltar",
    "submit": "Enviar",
    "support": "Contacta con el soporte",
    "upgrade": "Actualizar",
    "createLayer": "Crear capa",
    "disable": "Desactivar",
    "enable": "Habilitar",
    "copy": "Copiar",
    "maximise": "Maximizar",
    "minimise": "Minimiza",
    "retry": "Reintentar"
  },
  "toasts": {
    "creating_resource": "Creando {{ resource }} Te avisaremos cuando esté listo",
    "creation_completed": "Se completó la creación de {{ resource }}",
    "resource_complete": "{{ resource }} completado"
  },
  "selected": "Seleccionado {{ selectedNumber }}",
  "no_children_available": "No hay {{ childType }} disponible",
  "loading...": "Cargando...",
  "saving": "Ahorrando",
  "pending_save": "Pendiente de guardar",
  "saved": "Guardado",
  "creating": "Creando",
  "errorLoading": "Error al cargar {{ resourceName }}",
  "yes": "Sí",
  "no": "No",
  "none": "Ninguno",
  "selection": {
    "none_selected": "No se ha seleccionado ninguno",
    "all_selected": "Todos seleccionados",
    "selected": "Seleccionado"
  },
  "upload": {
    "select_csv": "Seleccione un archivo CSV",
    "change_csv": "Cambiar archivo CSV",
    "upload_errors_placeholder": "Si hay algún problema con tu archivo, aparecerá aquí",
    "import_complete": "La importación se completó correctamente"
  },
  "sort": {
    "most_relevant": "Lo más relevante"
  },
  "settings": "Ajustes",
  "no_results": "Sin resultados",
  "name": "Nombre",
  "in_development": "[En desarrollo]",
  "exports": {
    "success_message": "{{ exportName }} se exportó correctamente. Haga clic en el enlace para descargarlo",
    "error_message": "No se pudo exportar {{ exportName }} Vuelva a intentarlo más tarde o póngase en contacto con el servicio de asistencia de Iventis.",
    "start_message": "La exportación de {{ exportName }} ha comenzado, te avisaremos cuando esté lista"
  },
  "all": "¿Todas",
  "copied_to_clipboard": "Copiado al portapapeles",
  "click_for_details": {
    "whole": "Haga clic aquí para obtener más información",
    "click": "Haga clic",
    "for_more": "para obtener más detalles"
  },
  "here": "aquí",
  "delete_confirmation_message": "¿Estás seguro de que quieres eliminar {{ entity }}",
  "unavailable": "No disponible",
  "link": "Enlace",
  "powered_by": "Impulsado por",
  "boolean": {
    "true": "Cierto",
    "false": "Falso"
  },
  "delete": "Eliminar",
  "learnMore": "Obtenga más información",
  "items": "artículos",
  "csv": "csv",
  "success": "Éxito",
  "alert": "Alerta",
  "warning": "Advertencia",
  "error": "Error"
}